var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 67.51,
    viewBox: "0 0 60 67.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_1",
    "data-name": "Uni\\xE3o 1",
    d: "M-5990.121-1418.49a2.261,2.261,0,0,1-2.489-1.93v-14.986a31.08,31.08,0,0,0,11.063,8.656v6.33a2.258,2.258,0,0,1-2.488,1.93Zm11.443-9.867a29.89,29.89,0,0,1-9.535-6.43,29.9,29.9,0,0,1-6.431-9.536A29.823,29.823,0,0,1-5997-1456a29.821,29.821,0,0,1,2.357-11.676,29.921,29.921,0,0,1,6.431-9.536,29.892,29.892,0,0,1,9.535-6.43A29.827,29.827,0,0,1-5967-1486a29.826,29.826,0,0,1,11.678,2.358,29.891,29.891,0,0,1,9.536,6.43,29.886,29.886,0,0,1,6.43,9.536A29.81,29.81,0,0,1-5937-1456a29.812,29.812,0,0,1-2.357,11.678,29.869,29.869,0,0,1-6.43,9.536,29.9,29.9,0,0,1-9.536,6.43A29.827,29.827,0,0,1-5967-1426,29.824,29.824,0,0,1-5978.678-1428.357Zm-6.962-27.594a18.565,18.565,0,0,0,18.6,18.49,18.564,18.564,0,0,0,18.6-18.49,18.563,18.563,0,0,0-18.6-18.488A18.563,18.563,0,0,0-5985.64-1455.951Z",
    transform: "translate(5997 1486.001)",
    fill: "#1f0533"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.cde07ff1.svg";
export { ForwardRef as ReactComponent };